<template>
  <div id="Chart">
    <Head />
    <div class="chart">
      <div class="leftNav">
        <decLeftNav ref="LeftNav"/>
      </div>
      <div class="Main">
        <img src="../../assets/Declare/13.png">
      </div>
    </div>
    <Foot />
  </div>
</template>
<script>
import Head from "../../components/Head";
import Foot from "../../components/Foot";
import decLeftNav from "../../components/decLeftNav";
export default {
  name:"Chart",
  components: {
    Head,
    Foot,
    decLeftNav
  },
  mounted() {
    if(!sessionStorage.getItem("name")){
      this.$router.replace("/Declare")
    }
    this.$refs.LeftNav.isTable()
  },
}
</script>
<style lang="less" scoped>
  #Chart{
    width: 100%;
    min-width: 1000px;
    .chart{
      margin-top: 0.4rem;
      width: 100%;
      padding: 0 1.35rem;
      font-size: 0.18rem;
      display: flex;
      align-items: stretch;
      .leftNav{
        padding-right: 0.4rem;
        border-right: 0.01rem solid #E4E4E4;
      }
      .Main{
        width: 13.5rem;
        margin-left: 0.5rem;
        padding: 0.15rem;
        display: flex;
        >img{
          width: 100%
        }
      }
    }
  }
</style>